export default __webpack_public_path__ + "static/media/instagram.22e52a06.svg";